module.exports = ".success-message {\n  color: #e2202b; }\n\n#success {\n  text-align: center; }\n\n.infoform {\n  text-align: center; }\n\n.infoform .button {\n    cursor: pointer;\n    margin: 1em auto;\n    display: inline-block;\n    border-radius: 40px;\n    height: 40px;\n    line-height: 40px;\n    width: auto;\n    padding: 0 50px;\n    background-color: #e2202b;\n    color: #ffffff;\n    font-family: 'Roboto-b', Arial, Helvetica, sans-serif;\n    font-size: 1.2em;\n    text-decoration: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-view/end-of-study/end-of-study.component.scss
// module id = ./src/app/main-view/end-of-study/end-of-study.component.scss
// module chunks = main